"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = nilDefault;
/**
 * Verifies if `value` is `undefined` or `null` and returns `defaultValue`. In other case returns `value`.
 *
 * @ignore
 * @function nilDefault
 * @param {*} value The value to verify.
 * @param {*} defaultValue The default value.
 * @return {*} Returns `defaultValue` if `value` is `undefined` or `null`, otherwise `defaultValue`.
 */

function nilDefault(value, defaultValue) {
  return value == null ? defaultValue : value;
}

module.exports = exports["default"];